// extracted by mini-css-extract-plugin
export var buttonContainer = "_80-1";
export var fontSizeSelect = "_80-3";
export var formatSelect = "_80-2";
export var formats = "_80-4";
export var hidden = "_80-5";
export var icon = "_80-6";
export var select = "_80-0";